import {NgModule} from '@angular/core';
import {RcFunctionsService} from './rc-functions/rc-functions.service';
import {RcTimeService} from './rc-time/rc-time.service';
import {RcNumberService} from './rc-number/rc-number.service';
import {RcEventBusService} from './rc-event-bus/rc-event-bus.service';
import {RcApiService} from './rc-api/rc-api.service';
import {RcAuthService} from './rc-auth/rc-auth.service';
import {RcTranslateService} from './rc-translate/rc-translate.service';
import { JwtInterceptor } from './rc-auth/jwt.interceptor';
import {RcInviewService} from './rc-inview/rc-inview.service';
import {HttpClientModule} from '@angular/common/http';
import {RcDeviceService} from './rc-device/rc-device.service';
import {RcAppPreloadingStrategy} from './rc-app-preloading-strategy/rc-app-preloading-strategy';

/**
 * Rc UTILS module
 * Rc services infrastructure
 *
 * @example
 * import { RcUtilsModule } from '@realcommerce/rc-utils';
 *
 * @NgModule({
 *    declarations: [
 *      AppComponent
 *    ],
 *    imports: [
 *      BrowserModule,
 *      RcUtilsModule
 *    ],
 *    providers: [],
 *    bootstrap: [AppComponent]
 *  })
 *   export class AppModule { }
 */
@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        RcFunctionsService,
        RcTimeService,
        RcNumberService,
        RcEventBusService,
        RcApiService,
        RcAuthService,
        JwtInterceptor,
        RcTranslateService,
        RcInviewService,
        RcDeviceService,
        RcAppPreloadingStrategy
    ],
    declarations: [],
    exports: []
})
export class RcUtilsModule {
}
